export default {
  // Common
  "Email": "Email",
  "Email *": "Email *",
  "Password": "Password",
  "Dashboard": "Dashboard",
  "Overview": "Overview",
  "Giving": "Giving",
  "GIVING": "GIVING",
  "History": "History",
  "Subscriptions": "Planned Christian Giving (PCG)",
  "Planned Giving": "Planned Christian Giving",
  "SUBSCRIPTIONS": "PLANNED CHRISTIAN GIVING (PCG)",
  "Planned Christian Giving": "Planned Christian Giving",
  "Recurring Instructions": "Recurring Instructions",
  "Tax Receipts": "Tax Receipts",
  "Login": "Login",
  "Logout": "Logout",
  "Cancel": "Cancel",
  "Disabled": "Disabled",
  "Do Not Unsubscribe": "Do Not Cancel",
  "Confirm": "Confirm",
  "Complete Payment": "Complete Payment",
  "Confirm Payment": "Confirm Payment",
  "Processing...": "Processing...",
  "OK": "OK",
  "Error": "Error",
  "Success": "Success",
  "Back": "Back",
  "Save": "Save",
  "Type": "Type",
  "Edit": "Edit",
  "Delete": "Delete",
  "Download": "Download",
  "View": "View",
  "Actions": "Actions",
  "Subscription Ref ID: ": "Planned Christian Giving Ref ID: ",
  "Subscription ID": "Planned Christian Giving ID",
  "Subscription Details": "Planned Christian Giving Details",
  "Subscription Status": "Planned Christian Giving Status",
  "Start Date": "Start Date",
  "Customer ID": "Customer ID",
  "Token ID": "Token ID",
  "Unsubscribe": "Cancel",
  "Last Payment Date": "Last Payment Date",
  "Details": "Details",
  "Past Givings": "Past Givings",
  "No past givings found": "No past givings found",
  "Close": "Close",
  "Are you sure you want to unsubscribe this PCG instruction?": "Are you sure you want to cancel this PCG instruction?",
  "The subscription was successfully cancelled.": "The subscription was successfully cancelled.",
  "Subscription Cancelled": "Subscription Cancelled",
  "Filter": "Filter",
  "Filter Options": "Filter Options",
  "Date (From)": "Date (From)",
  "Date (To)": "Date (To)",
  "Saving...": "Saving...",
  "Loading...": "Loading...",
  "(Optional)": "(Optional)",
  "Password *": "Password *",
  "Confirm Password *": "Confirm Password *",
  "Weak Password": "Weak Password",
  "Password does not meet strength requirements. Please check the checklist and try again.": "Password does not meet strength requirements. Please check the checklist and try again.",
  "Phone": "Phone",
  "Service": "Service",
  "Since": "Since",
  "Payment Method": "Payment Method",
  "Search": "Search",
  "Pending": "Pending",
  "Completed": "Completed",
  "Cancelled": "Cancelled",
  "Enabled": "Enabled",
  "Clear Filters": "Clear Filters",
  "Once": "one-time",
  "Monthly": "monthly",
  "Yearly": "yearly",

  // Receipt Selection
  "Require a receipt": "Require a receipt",
  "Do not require a receipt": "Do not require a receipt",

  // Payment Status
  "THANK YOU FOR YOUR SUPPORT!": "THANK YOU FOR YOUR SUPPORT!",
  "PAYMENT FAILED": "PAYMENT FAILED",

  // HomePage
  "Enter the 6-digit code": "Enter the 6-digit code",
  "Not a member yet?": "Not a member yet?",
  "Create an account": "Create an account",
  "Forgot Password?": "Forgot Password?",
  "Your account is pending verification. Please check your email for the verification code and": "Your account is pending verification. Please check your email for the verification code and",
  "enter it in this page": "enter it in this page",

  // Registration
  "CREATE ACCOUNT": "CREATE ACCOUNT",
  "Which Is Your Regular Service?": "Which Is Your Regular Service?",
  "There are errors in the form. Please check the form and try again.": "There are errors in the form. Please check the form and try again.",
  "Your email is registered but not verified. Please check your email for verification instructions.": "Your email is registered but not verified. Please check your email for verification instructions.",
  "Email Not Verified": "Email Not Verified",
  "Creating Account...": "Creating Account...",
  "Create Account": "Create Account",
  "Only numbers are allowed": "Only numbers are allowed",
  "This field is required": "This field is required",
  "This field must be a valid e-mail": "This field must be a valid e-mail",
  "Only English characters are allowed": "Only English characters are allowed",
  "Others": "Others",
  "Only Chinese characters are allowed": "Only Chinese characters are allowed",
  "Must be at least 8 characters long": "Must be at least 8 characters long",
  "Show password": "Show password",
  "Hide password": "Hide password",
  "At least 8 characters": "At least 8 characters",
  "At least 1 uppercase letter": "At least 1 uppercase letter",
  "At least 1 lowercase letter": "At least 1 lowercase letter",
  "At least 1 number or special character": "At least 1 number or special character",

  // Verify Account
  "VERIFY ACCOUNT": "VERIFY ACCOUNT",
  "Account Verified Successfully!": "Account Verified Successfully!",
  "Your account has been verified. Redirecting to login...": "Your account has been verified. Redirecting to login...",
  "A 6-digit verification code has been sent to your email address. Please enter the code below to verify your account.": "A 6-digit verification code has been sent to your email address. Please enter the code below to verify your account.",
  "Verification failed. Please check your code and try again.": "Verification failed. Please check your code and try again.",
  "6-Digit Verification Code": "6-Digit Verification Code",
  "000000": "000000",
  "Didn't receive the code?": "Didn't receive the code?",
  "Resending...": "Resending...",
  "Resend in {{count}}s": "Resend in {{count}}s",
  "Resend Code": "Resend Code",
  "Verifying...": "Verifying...",
  "Verify Account": "Verify Account",
  "Back to Login": "Back to Login",
  "A new verification code has been sent to your email.": "A new verification code has been sent to your email.",
  "Code Resent": "Code Resent",
  "Failed to resend verification code. Please try again.": "Failed to resend verification code. Please try again.",
  "Please enter a valid 6-digit verification code.": "Please enter a valid 6-digit verification code.",
  "Invalid Input": "Invalid Input",
  "Email is required to resend verification code.": "Email is required to resend verification code.",

  // Forgot Password
  "FORGOT PASSWORD": "FORGOT PASSWORD",
  "Enter your email address and we'll send you a verification code to reset your password.": "Enter your email address and we'll send you a verification code to reset your password.",
  "Failed to send verification code. Please try again.": "Failed to send verification code. Please try again.",
  "your.email@example.com": "your.email@example.com",
  "Please enter a valid email address.": "Please enter a valid email address.",
  "Sending...": "Sending...",
  "Send Verification Code": "Send Verification Code",

  // Verify Code
  "VERIFY CODE": "VERIFY CODE",
  "A 6-digit verification code has been sent to your email address. Please enter the code below to continue.": "A 6-digit verification code has been sent to your email address. Please enter the code below to continue.",
  "Verify Code": "Verify Code",
  "Back to Forgot Password": "Back to Forgot Password",

  // Reset Password
  "RESET PASSWORD": "RESET PASSWORD",
  "Enter your new password below.": "Enter your new password below.",
  "Failed to reset password. Please try again.": "Failed to reset password. Please try again.",
  "New Password": "New Password",
  "Password must be at least 8 characters": "Password must be at least 8 characters",
  "Enter new password": "Enter new password",
  "Passwords do not match": "Passwords do not match",
  "Re-enter your new password": "Re-enter your new password",
  "Confirm New Password": "Confirm New Password",
  "Your password has been successfully reset. You can now login with your new password.": "Your password has been successfully reset. You can now login with your new password.",
  "Password Reset Successful": "Password Reset Successful",
  "Passwords do not match. Please try again.": "Passwords do not match. Please try again.",
  "Password Mismatch": "Password Mismatch",
  "Please fill in all required fields correctly.": "Please fill in all required fields correctly.",
  "Resetting...": "Resetting...",
  "Reset Password": "Reset Password",

  // Dashboard
  "Give": "Give",
  "PCGID: ": "PCGID: ",
  "Last Giving": "Last Giving",
  "Giver for ": "Giver for ",
  "month": "month",
  "months": "months",
  "HKD": "HKD",
  "Total Amount (Fiscal Year To Date)": "Total Amount (Fiscal Year To Date)",
  "RECENT GIVING": "RECENT GIVING",
  "Date": "Date",
  "Amount": "Amount",
  "Fund": "Fund",
  "Next Billing Date": "Next Billing Date",
  "Recurring Monthly Amount": "Recurring Monthly Amount",
  "Status": "Status",
  "Ref ID": "Ref ID",
  "No recent giving found": "No recent giving found",

  // Give Page
  "FREQUENCY": "FREQUENCY",
  "AMOUNT": "AMOUNT",
  "PAYMENT CONFIRMATION": "PAYMENT CONFIRMATION",
  "Please Note: By choosing 'Do Not Require A Receipt', no receipt shall be issued or requested in the future regards to the giving, yet email is compulsory for each giving for issuing confirmation email and documentation purpose.": "Please Note: By choosing 'Do Not Require A Receipt', no receipt shall be issued or requested in the future regards to the giving, yet email is compulsory for each giving for issuing confirmation email and documentation purpose.",
  "Click this button to proceed to the QFPay payment page": "Click this button to proceed to the QFPay payment page",
  "GIVE ": "GIVE ",
  " NOW": " NOW",
  "GIVE {{amount}} NOW": "GIVE {{amount}} NOW",
  "Payment Failed": "Payment Failed",
  "An error occurred during payment. Please try again.": "An error occurred during payment. Please try again.",

  // History
  "HISTORY": "HISTORY",
  "GIVING RECORD": "GIVING RECORD",

  // Subscriptions
  "Planned Amount": "Planned Amount",
  "Planned Status": "Planned Status",

  // Profile
  "Profile": "Profile",
  "MY PROFILE": "MY PROFILE",
  "Personal Information": "Personal Information",
  "First Name (English) *": "First Name (English) *",
  "Last Name (English) *": "Last Name (English) *",
  "First Name (Chinese)": "First Name (Chinese)",
  "Last Name (Chinese)": "Last Name (Chinese)",
  "Name on Tax Receipt": "Name on Tax Receipt",
  "Name on Tax Receipt *": "Name on Tax Receipt *",
  "Used for issuing tax receipt. Default to First Name and Last Name": "Used for issuing tax receipt. Default to First Name and Last Name",
  "Phone *": "Phone *",
  "Change Password (Optional)": "Change Password (Optional)",
  "Leave password fields blank if you don't want to change your password.": "Leave password fields blank if you don't want to change your password.",
  "Current Password": "Current Password",
  "Your profile has been updated successfully.": "Your profile has been updated successfully.",
  "Save Profile": "Save Profile",

  // Receipts
  "TAX RECEIPTS": "TAX RECEIPTS",
  "ISSUED TAX RECEIPTS": "ISSUED TAX RECEIPTS",
  "Financial Year:": "Financial Year:",
  "Receipt No.": "Receipt No.",

  // Not Found
  "Page not found": "Page not found",
  "Redirecting to dashboard in ": "Redirecting to dashboard in ",

  // Portal Header
  "The login session is expired. Please login again.": "The login session is expired. Please login again.",
  "Are you sure you want to logout?": "Are you sure you want to logout?",

  // File Upload
  "Drop file here to upload": "Drop file here to upload",
  "Drop file here or click to upload.": "Drop file here or click to upload.",
  "Accept file upload within 10 MB": "Accept file upload within 10 MB",

  // General List Layout
  "The ": "The ",
  " is sent to the customer successfully.": " is sent to the customer successfully.",
  " Sent": " Sent",
  "Failed to send the ": "Failed to send the ",
  " to the customer.": " to the customer.",
  "Failed to Send ": "Failed to Send ",
  "Selected ": "Selected ",
  "Item": "Item",
  "Items": "Items",

  // Delete Dialog
  "Delete ": "Delete ",
  "Are you sure you want to delete this ": "Are you sure you want to delete this ",

  // View Page Header
  "View ": "View ",

  // Entry Pages - additional keys
  "100.00": "100.00",
  "You have successfully made a giving to": "You have successfully made a giving to",
  "You have successfully made a {{term}} giving to ": "You have successfully made a {{term}} giving to ",
  "Amount: HKD ": "Amount: HKD ",
  "Ref ID: ": "Ref ID: ",
  "You can view your giving history in the": "You can view your giving history in the",
  "history": "history",
  "section": "section",
  "A confirmation email has been sent to your email address.": "A confirmation email has been sent to your email address.",
  "Unfortunately, your payment for the giving to": "Unfortunately, your payment for the giving to",
  "Unfortunately, your payment for the giving to ": "Unfortunately, your payment for the giving to ",
  "could not be processed": "could not be processed",
  " could not be processed.": " could not be processed.",
  "Please check your payment details and try again": "Please check your payment details and try again",
  "Please check your payment details and try again.": "Please check your payment details and try again.",
  "TRY AGAIN": "TRY AGAIN",
  "Need help": "Need help",
  "Contact Support": "Contact Support",
  "Need help?": "Need help? Please contact the <hyperlink>organization</hyperlink> for assistance.",

  // Confirmation Page
  "Confirm Recurring Payment": "Confirm Recurring Payment",
  "Please review your recurring payment details before confirming": "Please review your recurring payment details before confirming",
  "Confirm and Proceed to Payment": "Confirm and Proceed to Payment",
  "Edit Details": "Edit Details",
};
